import React from 'react';

export default function PurchaseButton({
  data,
  user,
  is_free_event,
  has_ticket_prices,
  is_members_only,
  is_ymc_only,
  custom_registration_button,
  onShowPurchaseForm,
}) {
  const hasPaidTicketPrices = () => {
    const prices = data?.prices;
    if (!prices) return false;

    const directPrices = [prices.member, prices.young_member, prices.non_member];
    const additionalPrices = Array.isArray(prices.additional)
      ? prices.additional.map((ticket) => ticket?.price)
      : [];

    return [...directPrices, ...additionalPrices].some((price) => Number(price) > 0);
  };

  if(!data?.show_purchase_button){
    return;
  }

  const has_custom = custom_registration_button?.has_custom_registration_link ?? false;
  const label = custom_registration_button?.label || '';
  const link = custom_registration_button?.link || '';
  const is_any_member = user?.is_any_member ?? false;
  const is_member = user?.is_member ?? user?.is_corporate_member ?? false;

  const buttonLabel = is_free_event ? 'Register Now' : 'Buy Tickets';
  const disableBuyTickets = !is_free_event && (!has_ticket_prices || !hasPaidTicketPrices());

  // Not logged in
  if (!user?.logged_in) {
    const redirect = data?.event_id ? `?redirect=${data.event_id}` : '';
    return (
      <>
        <a href={`/log-in${redirect}`} id="login/signup">
          <button type="button" className="mbs-16 styled">
            Login/Signup to Register for Event*
          </button>
        </a>
        <p>*You must be logged into your user account in order to register for the event/purchase tickets</p>
      </>
    );
  }

  // Members only: non-member
  if (is_members_only && !is_any_member) {
    return (
      <div className="wp-block-buttons">
        <div className="wp-block-button">
          <a className="wp-block-button__link" href="/become-a-member">
            Become a Member
          </a>
        </div>
      </div>
    );
  }

  // YMC only: member but not YMC
  if (is_ymc_only && is_member) {
    return (
      <div className="wp-block-buttons">
        <div className="wp-block-button">
          <a className="wp-block-button__link" href="/upcoming-events">
            Upcoming Events
          </a>
        </div>
      </div>
    );
  }

  // Members only + member + custom link (only show when link and label exist)
  if (is_members_only && is_any_member && has_custom && link && label) {
    return (
      <div className="wp-block-buttons">
        <div className="wp-block-button">
          <a className="wp-block-button__link" href={link}>
            {label}
          </a>
        </div>
      </div>
    );
  }

  // Custom link only (open to all) — only show when link and label exist
  if (has_custom && link && label) {
    return (
      <div className="wp-block-buttons">
        <div className="wp-block-button">
          <a className="wp-block-button__link" href={link}>
            {label}
          </a>
        </div>
      </div>
    );
  }

  // Default: show purchase button (ticketed or member)
  return (
    <button
      type="button"
      id="purchase-tickets"
      className="mbs-16 styled"
      disabled={disableBuyTickets}
      onClick={onShowPurchaseForm}
    >
      {buttonLabel}
    </button>
  );
}
